const NAV_BUTTON_WIDTH = 32; // NOTE: Consider navigation buttons when need to scroll.

// NOTE: Need to consider left/right paddings in breakpoint
const DESKTOP_HD_BREAKPOINT = 1440;
const DESKTOP_HD_OFFSET = 48;

function getOffset() {
  const clientWidth = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );

  if (clientWidth >= DESKTOP_HD_BREAKPOINT) {
    return DESKTOP_HD_OFFSET;
  }
  return NAV_BUTTON_WIDTH;
}

export function scrollList({ wrapper, list, item }) {
  const offset = getOffset();
  const { width: itemWidth } = item.getBoundingClientRect();
  const { width: wrapperWidth } = wrapper.getBoundingClientRect();

  let scroll;
  if (item.offsetLeft < list.scrollLeft + offset) {
    scroll = item.offsetLeft - offset;
  } else if (item.offsetLeft + itemWidth > wrapperWidth - offset) {
    scroll = item.offsetLeft - (wrapperWidth - itemWidth);
  }

  if (typeof scroll !== 'undefined' && list.scroll) {
    list.scroll(scroll, 0);
  }
}

export default {
  scrollList
};
